import { css } from '@emotion/css';

import boxShadowMixin from '@editor2/styles/mixins/boxShadow';
import { colors } from '@editor2/styles/colors';
import { pageCommon } from '@editor2/styles/page';

export const pageGroupPage = css`
	${pageCommon}

	.tocTabs {
		a {
			color: ${colors.mainText};
			border-radius: 0;
		}

		.nav-link.disabled {
			background-color: ${colors.background};
		}
	}

	.nav-tabs .nav-link.active {
		border-top-color: white;
	}
`;

export const pageGroupEditorContainer = css`
	padding: 30px 40px;
	font-size: 14px;

	.pageGroupName {
		font-weight: 600;
		margin-bottom: 30px;
	}
`;

export const contentBlock = css`
	padding: 20px 40px;
	color: ${colors.mainText};

	.addButton {
		font-size: 14px;
		margin-top: 15px;
		border-color: ${colors.border};
		background-color: inherit;
		color: ${colors.mainText};
		${boxShadowMixin(1)};

		svg {
			margin-right: 10px;
		}

		:hover {
			background-color: ${colors.background};
		}
	}
`;

export const pageContainer = css`
	margin-bottom: 15px;
`;

export const headerContainer = css`
	font-weight: 600;
	line-height: 1.2;
	background-color: ${colors.background};
	border-radius: 4px;
	padding: 12px 10px;
	margin-bottom: 5px;
	cursor: grab;
	position: relative;

	:hover {
		.menu {
			display: flex;
		}
	}

	.menu {
		position: absolute;
		left: -43px;
		top: 13px;
		padding: 0 10px;
		display: none;

		svg:hover {
			background-color: ${colors.background};
			cursor: pointer;
		}
	}

	.headerText {
		display: flex;
		align-item: center;
		justify-content: space-between;

		svg {
			cursor: pointer;
		}

		a {
			color: ${colors.mainText};
		}

		a:hover {
			cursor: pointer;
			text-decoration: underline;
		}

		span {
			color: ${colors.secondaryText};
		}
	}
`;

export const toolsBlock = css`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding: 20px 40px 0;

	button {
		margin-left: 15px;
		font-size: 14px;
		border-color: ${colors.border};

		:hover {
			color: ${colors.mainText};
			border-color: ${colors.border};
			background-color: ${colors.background};
		}

		svg {
			margin-right: 5px;
		}
	}
`;
